function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25 3.125C12.9199 3.125 3.125 12.9199 3.125 25C3.125 37.0801 12.9199 46.875 25 46.875C37.0801 46.875 46.875 37.0801 46.875 25C46.875 12.9199 37.0801 3.125 25 3.125ZM32.0361 25.3369L21.3721 33.0957C21.3136 33.1377 21.2447 33.1628 21.1729 33.1682C21.1011 33.1736 21.0292 33.1591 20.9651 33.1263C20.9011 33.0935 20.8472 33.0437 20.8096 32.9823C20.772 32.9209 20.7521 32.8503 20.752 32.7783V17.2705C20.7517 17.1984 20.7715 17.1276 20.809 17.066C20.8465 17.0044 20.9004 16.9544 20.9646 16.9215C21.0288 16.8886 21.1009 16.8742 21.1728 16.8798C21.2447 16.8854 21.3137 16.9107 21.3721 16.9531L32.0361 24.707C32.0865 24.7427 32.1276 24.7899 32.156 24.8447C32.1843 24.8995 32.1991 24.9603 32.1991 25.022C32.1991 25.0837 32.1843 25.1445 32.156 25.1993C32.1276 25.2541 32.0865 25.3013 32.0361 25.3369Z",
  fill: "#262626"
});

var SvgPlayCircle = function SvgPlayCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlayCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/play-circle.0de4a2c9.svg";
export { ForwardRef as ReactComponent };